import { createBrowserRouter, Navigate, type RouteObject } from 'react-router-dom';
import { ROUTES } from '@/shared/config/constants';
import { AppShell } from '@/widgets/app-shell';
import { LoginPage } from '@/pages/login';
import { ForgotPasswordPage } from '@/pages/forgot-password';
import { ResetPasswordPage } from '@/pages/reset-password';
import { SignupFlow } from '@/features/auth/signup';
import { MatchesPage, MatchDetailPage } from '@/pages/matches';
import { ChatListPage, ChatConversationPage } from '@/pages/chat';
import { CrmPage } from '@/pages/crm';
import { MentorPage } from '@/pages/mentor';
import { ProfilePage } from '@/pages/profile';
import { NotificationsPage } from '@/pages/notifications';
import { NotFoundPage } from '@/pages/not-found';
import { ProtectedRoute } from './ProtectedRoute';
import { PublicRoute } from './PublicRoute';
import { OnboardingGuard } from './OnboardingGuard';

const routes: RouteObject[] = [
  {
    path: ROUTES.ROOT,
    element: <Navigate to={ROUTES.LOGIN} replace />,
  },
  {
    element: <PublicRoute />,
    children: [
      {
        element: <LoginPage />,
        path: ROUTES.LOGIN,
      },
      {
        element: <ForgotPasswordPage />,
        path: ROUTES.FORGOT_PASSWORD,
      },
      {
        element: <ResetPasswordPage />,
        path: ROUTES.RESET_PASSWORD,
      },
    ],
  },
  {
    // Signup unificado: público (cadastro) + autenticado-sem-onboarding (perfil)
    path: ROUTES.REGISTER,
    element: <SignupFlow />,
  },
  {
    element: <OnboardingGuard />,
    children: [{ path: ROUTES.ONBOARDING, element: <Navigate to={ROUTES.REGISTER} replace /> }],
  },
  {
    element: <ProtectedRoute />,
    children: [
      {
        element: <AppShell />,
        path: ROUTES.APP.ROOT,
        children: [
          { index: true, element: <Navigate to={ROUTES.APP.MATCHES} replace /> },
          { path: 'matches', element: <MatchesPage /> },
          { path: 'matches/:id', element: <MatchDetailPage /> },
          { path: 'chat', element: <ChatListPage /> },
          { path: 'chat/:matchId', element: <ChatConversationPage /> },
          { path: 'crm', element: <CrmPage /> },
          { path: 'mentor', element: <MentorPage /> },
          { path: 'profile', element: <ProfilePage /> },
          { path: 'notifications', element: <NotificationsPage /> },
        ],
      },
    ],
  },
  { path: '*', element: <NotFoundPage /> },
];

export const router: ReturnType<typeof createBrowserRouter> = createBrowserRouter(routes);
